import type { Event } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { message } from 'ui';
import { REMINDER_REGULAR_USER_INVITATION_LIMIT } from '../../../../invitations-form-content';
import { useEventInviteesCount } from '../../../hooks';

type P = {
  event: Event;
  onInvite: () => void;
};

export const useInviteMorePeople = ({ event, onInvite }: P) => {
  const { isEventsAdmin } = usePermissions();
  const { t } = useTranslation();
  const eventIndividualInviteesCount = useEventInviteesCount(event);

  return useCallback(() => {
    if (!isEventsAdmin({}) && eventIndividualInviteesCount >= REMINDER_REGULAR_USER_INVITATION_LIMIT) {
      message.error(
        t("You've reached the {{count}}-invitation limit for your role. Remove someone to add another.", {
          count: REMINDER_REGULAR_USER_INVITATION_LIMIT,
        }),
      );

      return;
    }

    onInvite();
  }, [eventIndividualInviteesCount, isEventsAdmin, onInvite, t]);
};
